// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LTtwM","rootMobile":"styles_rootMobile__3uOsD"};